const BASE_URL    = process.env.REACT_APP_API_URL    || 'https://api-clai.xpertus.net';
const WEBHOOK_URL = process.env.REACT_APP_WEBHOOK_URL || 'https://n8n.xpertus.net/webhook/clai-entry';

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function apiFetch(path, options = {}, retries = 3) {
  const url = `${BASE_URL}${path}`;
  let lastError;

  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const response = await fetch(url, {
        headers: { 'Content-Type': 'application/json', ...options.headers },
        ...options,
      });
      const data = await response.json();
      if (!response.ok) {
        const err = new Error(data.error || `HTTP ${response.status}`);
        err.status = response.status;
        err.code = data.code;
        if (response.status >= 400 && response.status < 500) throw err;
        lastError = err;
        if (attempt < retries) await sleep(Math.pow(2, attempt - 1) * 1000);
        continue;
      }
      return data;
    } catch (err) {
      if (err.status) throw err;
      lastError = err;
      if (attempt < retries) await sleep(Math.pow(2, attempt - 1) * 1000);
    }
  }
  throw lastError;
}

export async function sendToWebhook(content, contextId = null, retries = 3) {
  let lastError;
  const payload = { content };
  if (contextId) payload.context_id = contextId;
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const response = await fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (response.ok) return { ok: true };
      const data = await response.json().catch(() => ({}));
      lastError = new Error(data.message || `HTTP ${response.status}`);
      if (attempt < retries) await sleep(Math.pow(2, attempt - 1) * 1000);
    } catch (err) {
      lastError = err;
      if (attempt < retries) await sleep(Math.pow(2, attempt - 1) * 1000);
    }
  }
  throw lastError;
}
